import QuizGameList from './QuizGameList.vue';
import QuizGame from './QuizGame.vue';

export default {
  QuizGameList,
  QuizGame,
};
